import type { ListedCompany } from './vuex';

export default {
  companies: [] as ListedCompany[],
};
